import { Trophy } from 'lucide-react-native';
import { useEffect, useState } from 'react';

import { PickerField } from '@/components/PickerField';
import { FALLBACK_OTHER, FALLBACK_SPORTS, sportsService } from '@/services/sports';

/**
 * Prop-driven sport picker. ALWAYS fed by the live /api/v1/sports list
 * (bundled FALLBACK only when the fetch fails) — the 14-vs-26 sport-list
 * mismatch bug came from a hardcoded copy of this exact list; do not inline
 * one here. The Input + dropdown itself lives in PickerField.
 */
export function SportPicker({
  value,
  onSelect,
}: {
  value: string | null;
  onSelect: (sport: string | null) => void;
}) {
  const [sports, setSports] = useState<string[]>([...FALLBACK_SPORTS, FALLBACK_OTHER]);

  useEffect(() => {
    let cancelled = false;
    sportsService
      .fetch()
      .then(({ sports: list, other }) => {
        if (!cancelled) setSports([...list, other]);
      })
      .catch(() => {
        // Fallback list already in state; server list is authoritative when reachable.
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <PickerField
      label="Sport"
      icon={Trophy}
      options={sports}
      value={value}
      onSelect={onSelect}
      placeholder="Pick or type your sport"
      emptyLabel="No matching sport."
    />
  );
}
